module.exports = __webpack_public_path__ + "static/media/9.bd312a47.jpg";